<cagov-nav-megamenu
    [appName]="appName"
    [shortName]="shortName"
    [appEnvironment]="appEnvironment"
    [appVersion]="appVersion"
    [navItems]="navItems"
    (loginRequested)="loginRedirect()"
    (navigationEvent)="handleNavEvent($event)"
    (onMainContent)="backToTop($event)"
    [showSearchControl]="true"
></cagov-nav-megamenu>
<div
    #mainContent
    id="main-content"
    tabindex="-1"
    class="main-content"
    (window:resize)="onResize($event)"
>
    <a
        id="skip-to-content"
        href="#main-content"
        aria-label="Skip to content"
    ></a>
    <div>
        <div class="error alert alert-danger" role="alert" *ngIf="hasError">
            <h2 class="error-header">Startup Error</h2>
            An unexpected error occurred and we were unable to route you to the
            login page. To try again, click the link below. If you continue to
            have problems, please contact your delegated administrator or submit
            a service request via ServiceNow.
            <br />
            <br />
            <a (click)="navToLanding()">Click to Login</a>
        </div>
        <router-outlet *ngIf="!hasError && !isIframe"></router-outlet>
    </div>
    <span
        class="return-top"
        [ngClass]="{ 'is-visible': !atTop }"
        matTooltip="Back to top"
        (click)="backToTop($event)"
    ></span>
</div>
<cagov-footer
    class="global-footer"
    [title]="appName"
    [version]="appVersion"
    (onBackToTop)="backToTop($event)"
></cagov-footer>
